// src/components/ResponseInsights.tsx

import React, { useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useFabricService } from '../contexts/FabricServiceContext';
import { OverviewObject } from '../types/DataObject';
import { OverviewSelector } from './OverviewSelector';
import { AnimationConfig } from '../config/animationConfig';
import { OverviewContent } from './OverviewContent';
// import ThinkingEffect from './ThinkingEffect';
import './OverviewContent.scss';

interface ResponseInsightsProps {
  id: string;
  inProgress?: boolean;
}

export const ResponseInsights: React.FC<ResponseInsightsProps> = ({
  id,
  inProgress = false
}) => {
  const { fabricEvents } = useFabricService();
  const [selectedOverviewIndex, setSelectedOverviewIndex] = useState(0);

  const overviews = useMemo(() => {
    return fabricEvents
      .filter(
        (realtimeEvent) =>
          realtimeEvent.event.type === 'fabric.response.output_item.added' &&
          realtimeEvent.event.response_id === id &&
          realtimeEvent.event.item.output[0].recipient === 'overview'
      )
      .map(event => ({
        sender: event.event.item.output[0].sender,
        content: event.event.item.output[0].content as OverviewObject
      }));
  }, [fabricEvents, id]);

  const currentOverview = useMemo(() => {
    return inProgress ? overviews[overviews.length - 1]?.content : overviews[selectedOverviewIndex]?.content;
  }, [overviews, selectedOverviewIndex, inProgress]);

  if (!currentOverview) return null;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={`response-${id}-${selectedOverviewIndex}`}
        className='overview-content-container'
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: AnimationConfig.sections.transitionDuration,
          ease: AnimationConfig.easing.smooth
        }}
      >
        {/* <ThinkingEffect /> */}
        {!inProgress && overviews.length > 1 && (
          <OverviewSelector
            overviews={overviews}
            selectedOverview={selectedOverviewIndex}
            onOverviewChange={setSelectedOverviewIndex}
          />
        )}

        <OverviewContent
          overview={currentOverview}
          inProgress={inProgress}
          selectedOverviewIndex={selectedOverviewIndex}
        />
      </motion.div>
    </AnimatePresence>
  );
};